import React, { Component, } from 'react'
import PropTypes from 'prop-types'

import ShareIcon from 'components/icons/Share'

import './styles.css'

class ShareButton extends Component {

  static propTypes = {
    fill: PropTypes.string,
    width: PropTypes.number,
    actions: PropTypes.shape({
      openMagicDrawer: PropTypes.func.isRequired,
    }).isRequired,
  }

  static defaultProps = {
    fill: '#FFF',
    width: 24,
  }

  render() {
    const {
      actions,
      fill,
      width,
    } = this.props
    return (
      <button className="ShareButton" onClick={actions.openMagicDrawer}>
        <ShareIcon width={width} fill={fill} />
      </button>
    )
  }

}

export default ShareButton



// WEBPACK FOOTER //
// ./src/components/ShareButton/component.js